import React from 'react'
import TextEditor from "./text_editor";

export default function LeadGeneration({initialState, onDataChanged, props}) {
    return <div>
        {/*<hr/>*/}
        {/*<h5 className="hotspot-setting-header">Lead generation text</h5>*/}
        {/*<div className="hotspot-setting-info">*/}
        {/*    This is the text shown in the popups body.*/}
        {/*</div>*/}
        {/*<TextEditor initialEditorState={initialState}*/}
        {/*            onDataChanged={onDataChanged} />*/}
    </div>
}
